var _rect, _rect2, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 52,
    viewBox: "0 0 108 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 24,
    rx: 4,
    fill: "url(#paint0_linear_1467_33246)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56.5,
    y: 0.5,
    width: 51,
    height: 23,
    rx: 3.5,
    stroke: "url(#paint1_linear_1467_33246)",
    strokeOpacity: 0.5,
    strokeDasharray: "5 5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 28.5,
    width: 107,
    height: 23,
    rx: 3.5,
    stroke: "url(#paint2_linear_1467_33246)",
    strokeOpacity: 0.5,
    strokeDasharray: "5 5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1467_33246",
    x1: 53.5,
    y1: 27.5,
    x2: -51.1603,
    y2: -26.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#846DB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29336B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1467_33246",
    x1: 82,
    y1: 0,
    x2: 82,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1467_33246",
    x1: 54,
    y1: 28,
    x2: 54,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.36e423c8ee141344f4cc0f97c3abcc01.svg";
export { ForwardRef as ReactComponent };